import { ofetch } from 'ofetch'

// =========================================================================
// getPlainHeaders — ubah instance Headers jadi objek biasa, supaya ofetch
// (dan onRequest di bawah) tidak perlu asumsi bentuk headers yang diterima.
// =========================================================================
const getPlainHeaders = headersInst => Object.fromEntries(headersInst.entries())

// =========================================================================
// $api — ofetch instance (existing, jangan dihapus)
// =========================================================================
export const $api = ofetch.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  async onRequest({ options }) {
    const accessToken = useCookie('accessToken').value
    if (accessToken) {
      if (options.headers instanceof Headers) {
        options.headers.set('Authorization', `Bearer ${accessToken}`)
      } else {
        options.headers = options.headers || {}
        options.headers['Authorization'] = `Bearer ${accessToken}`
      }
    }
  },
})

// =========================================================================
// useApi — wrapper untuk PintuKasir (BARU)
// =========================================================================
export const useApi = (url, options = {}) => {
  const accessToken = useCookie('accessToken').value
  const tenantSlug = useCookie('current_tenant')?.value

  const headers = new Headers(options.headers || {})
  headers.set('Accept', 'application/json')

  // ✅ TAMBAHKAN INI: JANGAN set Content-Type jika body adalah FormData
  // Biarkan browser set multipart/form-data + boundary otomatis
  const isFormData = options.body instanceof FormData
  if (!isFormData) {
    headers.set('Content-Type', 'application/json')
  }

  if (accessToken)
    headers.set('Authorization', `Bearer ${accessToken}`)
  if (tenantSlug)
    headers.set('X-Tenant', tenantSlug)

  return {
    get: (opts = {}) => $api(url, { ...options, ...opts, method: 'GET', headers: getPlainHeaders(headers) }),
    post: (opts = {}) => {
      const postHeaders = new Headers(headers)
      if (opts.body instanceof FormData) {
        postHeaders.delete('Content-Type')
      }
      return $api(url, { ...options, ...opts, method: 'POST', headers: getPlainHeaders(postHeaders) })
    },
    put: (opts = {}) => {
      const putHeaders = new Headers(headers)
      if (opts.body instanceof FormData) {
        putHeaders.delete('Content-Type')
      }
      return $api(url, { ...options, ...opts, method: 'PUT', headers: getPlainHeaders(putHeaders) })
    },
    patch: (opts = {}) => {
      const patchHeaders = new Headers(headers)
      if (opts.body instanceof FormData) {
        patchHeaders.delete('Content-Type')
      }
      return $api(url, { ...options, ...opts, method: 'PATCH', headers: getPlainHeaders(patchHeaders) })
    },
    delete: (opts = {}) => $api(url, { ...options, ...opts, method: 'DELETE', headers: getPlainHeaders(headers) }),
  }
}
